'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable import/prefer-default-export */
var getThemeIdFromIrisContent = exports.getThemeIdFromIrisContent = function getThemeIdFromIrisContent(content) {
    var _content$clientProper = content.clientProperties;
    _content$clientProper = _content$clientProper === undefined ? {} : _content$clientProper;
    var _content$clientProper2 = _content$clientProper.themes,
        contentThemes = _content$clientProper2 === undefined ? ['default'] : _content$clientProper2;

    return contentThemes[0];
};
/* eslint-enable import/prefer-default-export */
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/theme-provider/lib/cjs/util.js
 ** module id = 300
 ** module chunks = 0
 **/